import ActivityStepper from '../../../../../../components/ActivityStepper';
import { Drawer } from '../../../../../../components/elements/Drawer';
import useLayoutHook from '../../../../../../hooks/layoutHook';
import useUserAccount from '../../../../../../hooks/userAccountHook';
import CustomerInfo from '../../../../../../components/CustomerInfo';
import { useState } from 'react';
import { Policy } from '../../../../../../models/policy/Policy';
import { LuCalendarClock } from 'react-icons/lu';
import Tooltip from '../../../../../../components/ToolTip';
import { StickyNote } from 'lucide-react';


type PolicyDetailsDrawerContentProps = {
  policy?: Policy
  getOtherInformation: () => JSX.Element
  getPaymentAnalysisInformation: () => JSX.Element
  getRefereeDetails: () => JSX.Element
  getPolicyDocumentsInfo: () => JSX.Element
  onSetShowUpdates: (state: boolean) => void
  isOpen?: boolean
  onToggle?: () => void
}

const PolicyDetailsDrawerContent = ({ policy, getOtherInformation, getPaymentAnalysisInformation, getRefereeDetails, getPolicyDocumentsInfo,onSetShowUpdates, isOpen, onToggle }: PolicyDetailsDrawerContentProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { user } = useUserAccount();
  const { isMobile } = useLayoutHook();

  const drawerOpen = isOpen !== undefined ? isOpen : isDrawerOpen;
  
  const toggleDrawer = () => {
    if (onToggle) {
      onToggle();
    } else {
      setIsDrawerOpen(!isDrawerOpen);
    }
  };

  const policyTimeLine = ()=> {
    const activityStreams = policy?.activityStreams ?? [];
    const nonEndorsementActivities = activityStreams.filter(
      (a: any) => a?.type !== 'ENDORSEMENT'
    );

    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
            <div className=" flex flex-wrap gap-2 items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b dark:border-b-darkBg-border border-gray-200 bg-gray-50 dark:bg-darkBg">
              <h2 className="text-lg font-medium text-gray-900 dark:text-darkBg-mainText flex items-center">
                <LuCalendarClock className="h-6 w-6 mr-2 text-gray-500 dark:text-darkBg-mainText" />
                Policy Timeline
              </h2>
              <button onClick={() => onSetShowUpdates(true)} className="px-1.5 py-0.5 border-2 border-gray-600 dark:border-darkBg-mainText dark:text-darkBg-mainText text-gray-700 hover:bg-gray-50 dark:hover:bg-transparent text-xs font-medium rounded-full transition-all duration-200 flex items-center">
                <StickyNote className="h-4 w-4 mr-1.5" />
                Notes
                {policy?.updates && policy?.updates.length > 0 && (
                  <span className="ml-2 px-2 py-0.5 bg-gray-700 text-white text-xs font-bold rounded-full">
                    {policy?.updates.length}
                  </span>
                )}
              </button>
            </div>
            <div className="p-4 sm:p-6 overflow-y-auto h-full md:max-h-[34rem]">
              {nonEndorsementActivities.length > 0 ? (
                <ActivityStepper
                  activityStreams={nonEndorsementActivities}
                  orientation="vertical"
                  currentStep={0}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center font-semibold">
                  No activity
                </div>
              )}
            </div>
          </div>
    )
  }

  const endorsementTimeLine = () => {
    const activityStreams = policy?.activityStreams ?? [];
    const endorsementActivities = activityStreams.filter((a: any) => a?.type === 'ENDORSEMENT');

    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className=" flex flex-wrap gap-2 items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b dark:border-b-darkBg-border border-gray-200 bg-gray-50 dark:bg-darkBg">
          <h2 className="text-lg font-medium text-gray-900 dark:text-darkBg-mainText flex items-center">
            <LuCalendarClock className="h-6 w-6 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Endorsement History
          </h2>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto h-full md:max-h-[34rem]">
          {endorsementActivities.length > 0 ? (
            <ActivityStepper
              activityStreams={endorsementActivities}
              orientation="vertical"
              currentStep={0}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center font-semibold">
              No endorsements
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="relative">
      <div className="">
        {/* Toggle button */}
        <Tooltip message='View other info.'>
          <button
            onClick={toggleDrawer}
            className="fixed right-0 top-1/2 z-30 p-2 bg-primary-main text-white rounded-l-lg shadow-lg hover:bg-primary-main transition-colorscflex items-center gap-5"
            style={{ transform: 'translateY(-50%)' }}
          >
            
            {/* {isDrawerOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
              </svg>
            )} */}

            Other Info
          </button>
        </Tooltip>
      </div>

      {/* Drawer */}
      <Drawer isOpen={drawerOpen} onClose={() => onToggle ? onToggle() : setIsDrawerOpen(false)} position="right" size={isMobile ? 'full' : 600}>
        <div className="space-y-4 sm:space-y-6 mt-4 sm:mt-7 h-full max-h-[95vh] overflow-y-scroll">

          {/* Customer Information Section */}
          {policy?.applicant && (
            <CustomerInfo
              firstName={policy?.applicant?.firstName}
              lastName={policy?.applicant?.lastName}
              businessName={policy?.applicant?.businessName}
              email={policy?.applicant?.email}
              phoneNumber={policy?.applicant?.phoneNumber}
              otherPhone={policy?.applicant?.otherPhone}
              idNumber={policy?.applicant?.idNumber}
              id={policy.applicant.customerId}
              idVerified={policy?.applicant?.idVerified}
              emailVerified={policy?.applicant?.emailVerified}
              phoneVerified={policy?.applicant?.phoneVerified}
              score={policy?.applicant?.kycAnalysis?.score}
              risk={policy?.applicant?.kycAnalysis?.risk}
              type={policy?.applicant?.customerType}
              isClickable={true}
              query='fetchPolicy'
            />
          )}


          {/* Policy Timeline Section */}
          {policyTimeLine()}

          {endorsementTimeLine()}

          {/* Documents Section */}
          {/* {getPolicyDocumentsInfo()} */}

          {/* Other Information Section */}
          {/* {getOtherInformation()} */}

          {/* PaymentAnalysis */}
          {/* {getPaymentAnalysisInformation()} */}

          {(!policy?.isFullPayment() && policy?.isCommercial() && !user.isRideSharing() && policy?.referee?.phone)
            && getRefereeDetails()
          }

        </div>
      </Drawer>
    </div>
  )
}

export default PolicyDetailsDrawerContent